/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContinuationClaims/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function ContinuationClaims({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceCarrierForm/ContinuationClaims",
  onChange
  
}) {
let carrierContinuationClaimsRequiredValueData = fromData.useDataValue({ viewPath,
context: 'carrier',
path: 'continuation_claims_required',
})
let carrierContinuationClaimsRequiredChangeData = fromData.useDataChange({ viewPath,
context: 'carrier',
path: 'continuation_claims_required',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="carrier.continuation_claims_required"
 value={carrierContinuationClaimsRequiredValueData}
 onChange={carrierContinuationClaimsRequiredChangeData}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Continuation Claims Required"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}